export default __webpack_public_path__ + "static/media/home_bg_element_img.e0aaa4e5.png";